<template>
  <tr class="customer-item" v-if="user" @click="showModal = true" style="cursor: pointer">
    <td v-if="selectedBot.theme == 'toa'" class="text-xs-center pa-2">
      <template v-if="$store.state.toapainterpage.includes(selectedBot.pageid)">
        <v-btn
          depressed
          :dark="toastatus(user.painter_status) != 'None'"
          :disabled="toastatus(user.painter_status) == 'None'"
          :color="toatstatuscolor(user.painter_status)"
          @click.stop="showtoadialog = true"
          >{{ toastatus(user.painter_status) }}</v-btn
        >
        <v-dialog width="700px" v-if="showtoadialog" v-model="showtoadialog">
          <v-card>
            <v-card-text>
              <toa-painter-info
                @close="showtoadialog = false"
                @updateUserToa="updateUserToa"
                :user="user"
                v-model="user"
              ></toa-painter-info>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <template v-else>
        <v-btn
          depressed
          dark
          :color="toatstatuscolor(user.dealer_status)"
          @click.stop="showtoadialog = true"
          >{{ toastatus(user.dealer_status) }}</v-btn
        >
        <v-dialog width="700px" v-if="showtoadialog" v-model="showtoadialog">
          <v-card>
            <v-card-text>
              <toa-approve
                @close="showtoadialog = false"
                @updateUserToa="updateUserToa"
                :user="user"
              ></toa-approve>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
    </td>
    <td v-if="selectedBot.theme == 'hafele'">{{ user.emp_id }}</td>
    <td v-if="selectedBot.theme == 'centralhr'">{{ user.employee_id ? user.employee_id : '-' }}</td>
    <td>
      <v-avatar size="30">
        <img
          v-if="user.profile_pic"
          @error="onFailLoad"
          :src="user.profile_pic"
          width="30"
          height="30"
          :alt="user.first_name + ' ' + user.last_name"
        />
        <img
          v-else
          :src="'/static/img/assets/livechat/profile.png'"
          width="30"
          height="30"
          :alt="user.first_name + ' ' + user.last_name"
        />
      </v-avatar>
    </td>
    <td
      v-if="selectedBot.theme == 'sahapan'"
      style="min-width: 300px"
      :title="user.realname ? user.realname : ''"
    >
      <div style="display: inline-block; vertical-align: top; margin-top: 5px">
        {{ (user.realname ? user.realname : '-') | truncate(35) }}
      </div>
    </td>
    <td
      style="min-width: 300px"
      :title="
        (user.first_name ? user.first_name : '') + ' ' + (user.last_name ? user.last_name : '')
      "
    >
      <div style="display: inline-block; vertical-align: top; margin-top: 5px">
        {{
          ((user.first_name ? user.first_name : '') + ' ' + (user.last_name ? user.last_name : ''))
            | truncate(35)
        }}
      </div>
    </td>
    <td v-if="selectedBot.theme == 'toa'" style="min-width: 300px">
      <div style="display: inline-block; vertical-align: top; margin-top: 5px">
        {{ user.shop_id ? user.shop_id : '-' }}
      </div>
    </td>
    <td class="text-xs-center">
      <span style="color: #3b5998" v-if="user.app == 'facebook'">
        <em class="fab fa-facebook-square" />
      </span>
      <span style="color: #00c300" v-else-if="user.app == 'line'">
        <em class="fab fa-line" />
      </span>
    </td>
    <td>{{ user.gender ? $t(user.gender) : '-' }}</td>
    <td v-if="$store.state.niveapage.includes(selectedBot.pageid)">
      {{ user.usermessages ? $t(user.usermessages) : '-' }}
    </td>

    <td class="text-xs-center">
      {{ user.registertimestamp ? getFormatDate(user.registertimestamp, 'DD/MM/YYYY') : '-' }}
    </td>
    <td class="text-xs-center">
      {{ user.timestamp ? getFormatDate(user.timestamp, 'DD/MM/YYYY') : '-' }}
    </td>
    <td :class="{ 'background-gray': $store.getters.getPackage != 'premium' || isCoachlab }">
      <customer-item-value
        v-if="selectedBot.theme == 'scgworkplace'"
        :value="workplaceEmail ? workplaceEmail : user['email']"
        >{{ workplaceEmail ? workplaceEmail : user.email }}</customer-item-value
      >
      <customer-item-value v-else :value="user['email']">{{ user.email }}</customer-item-value>
    </td>
    <td :class="{ 'background-gray': $store.getters.getPackage != 'premium' || isCoachlab }">
      <customer-item-value :value="user['phoneno']">{{ user.phoneno }}</customer-item-value>
    </td>
    <td :class="{ 'background-gray': $store.getters.getPackage != 'premium' || isCoachlab }">
      <customer-item-value :value="user['status']">{{ user.status }}</customer-item-value>
    </td>
    <td class="text-xs-center" style="white-space: nowrap">
      <template v-if="userLocale">
        <flag :iso="userLocale.icon" />
      </template>
      <template v-else>-</template>
    </td>
    <td v-if="isBU">
      <customer-item-value :value="user['lineid']">{{ user.lineid }}</customer-item-value>
    </td>
    <td v-if="isBU">
      <customer-item-value :value="user['province']">{{ user.province }}</customer-item-value>
    </td>
    <td v-if="isBU">
      <customer-item-value :value="user['school']">{{ user.school }}</customer-item-value>
    </td>

    <td>
      <v-btn outline fab small class="extra-small">
        <em class="fas fa-align-left" />
      </v-btn>

      <v-dialog v-model="showModal" width="800">
        <v-card>
          <v-tabs
            v-if="selectedBot.theme == 'scgworkplace'"
            v-model="workplacetab"
            color="white"
            :slider-color="$vuetify.theme.primary"
          >
            <v-tab ripple :key="'Info'" :href="'#Info'">{{ $t('Info') }}</v-tab>
            <v-tab ripple :key="'Workplace'" :href="'#Workplace'">{{ $t('Workplace') }}</v-tab>
          </v-tabs>
          <div v-if="selectedBot.theme == 'scgworkplace' && workplacetab == 'Workplace'">
            <WorkplaceCustomer v-if="showModal" :key="user.id" v-model="user.id">
              <div slot="header" class="text-xs-right">
                <v-btn flat fab small class="extra-small" @click="showModal = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </WorkplaceCustomer>
          </div>
          <div v-else>
            <customer-detail v-if="showModal" :key="user.id" v-model="user.id">
              <div slot="header" class="text-xs-right">
                <v-btn flat fab small class="extra-small" @click="showModal = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </customer-detail>
          </div>

          <v-card-text class="text-xs-center">
            <v-btn outline color="grey" @click="showModal = false">{{ $t('cancel') }}</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- <a href="javascript:void(0)" class="btn btn-primary transparent btn-sm" style="margin-right: 5px; margin-bottom: 5px;"><em class="fab fa-facebook-messenger"/> Chat</a> -->
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import CustomerItemValue from '../CustomerItemValue'
import EditCustomerValue from '../EditCustomerValue'
import specialtext from '@/components/elements/specialtext'
import Tags from '@/components/elements/Tags'
import api from '@/api'
import CustomerDetail from '../CustomerDetail.vue'
import WorkplaceCustomer from '@/components/view/livechat/scgworkplace-customer.vue'
import ToaApprove from '../ToaApprove.vue'
import ToaPainterInfo from '../ToaPainterInfo.vue'
import multiselect from 'vue-multiselect'

export default {
  props: ['value'],
  data: function () {
    return {
      showtoadialog: false,
      user: undefined,
      showModal: false,
      showAllIntent: false,
      isEditTag: false,
      usertag: '',
      workplacetab: 'Workplace'
    }
  },
  components: {
    CustomerItemValue,
    EditCustomerValue,
    specialtext,
    Tags,
    CustomerDetail,
    WorkplaceCustomer,
    ToaApprove,
    ToaPainterInfo,
    multiselect
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    }),
    workplaceEmail() {
      var data = null
      if (this.value && this.value.sessionvalue) {
        try {
          data = JSON.parse(this.value.sessionvalue)
        } catch (error) {
          data = null
        }
        return data.mail ? data.mail : ''
      } else {
        return ''
      }
    },
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    filterIntent: function () {
      var vm = this
      return vm.user.intentlist.sort(function (a, b) {
        if (parseInt(a[1]) > parseInt(b[1])) {
          return -1
        }

        if (parseInt(a[1]) < parseInt(b[1])) {
          return 1
        }

        return 0
      })
    },
    userLocale: function () {
      var vm = this
      return config.locale.find(function (locale) {
        if (vm.user.locale == locale.value) {
          return locale.title
        }
      })
    },
    tags: function () {
      var vm = this
      if (vm.user.tags !== '' && vm.user.tags != null) {
        var usertags = vm.user.tags.split(',')
        return usertags
      } else {
        return []
      }
    },
    usertags: {
      get() {
        let vm = this
        if (vm.user && vm.user.tags && vm.user.tags !== '') {
          var usertags = []

          usertags = vm.user.tags.split(',')
          var result = []
          if (usertags) {
            usertags.map(function (tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag, index) {
            result.push(tag.text)
          })
        }
        vm.user.tags = result.join(',')
      }
    }
  },
  mounted: function () {
    this.user = this.value
    this.cached_tag = this.user.tags
    if (this.user.json_variable) {
      try {
        Object.assign(this.user, JSON.parse(this.user.json_variable))
      } catch (error) {}
    }
  },
  methods: {
    toatstatuscolor(status) {
      if (status == 'waiting for approval') return '#fb8c00'
      else if (status == 'approve') return 'green'
      else return 'rgb(201 201 201)'
    },
    toastatus(status) {
      if (status == 'waiting for approval') return 'Waiting'
      else if (status == 'approve') return 'Approved'
      else return 'None'
    },
    updateUserToa(payload) {
      this.user = payload
    },
    saveEditTag: function () {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        usersid: vm.user.id,
        tags: vm.user.tags
      }
      api.saveUserTags(data, function (error, response) {
        if (error) {
          console.error(error)
        }
        vm.cached_tag = vm.user.tags
        vm.isEditTag = false
      })
    },
    cancelEditTag: function () {
      this.user.tags = this.cached_tag
      this.isEditTag = false
    },
    onFailLoad: function () {
      this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    addUserTags: function (newTags) {
      this.usertags = newTags
    },
    checkUserTags(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 25) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onEditStatus: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        status: payload.customer_value
      }
      api.saveUserStatus(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditEmail: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        email: payload.customer_value
      }
      api.saveUserEmail(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditPhone: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        phoneno: payload.customer_value
      }
      api.saveUserPhoneno(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    }
  },
  watch: {
    value: function () {
      this.user = this.value
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/centralhr/CentralHRCustomerItem.vue